export interface BucketReportData {
  clientId: string;
  entityId: string;
  clientTaxPeriodId: number;
  companyCode: string;
  divisionCode: string;
  filingPeriod: Date | null;
  stateAbbreviation: string;
  countyName: string;
  cityName: string;
  taxType: string;
  stateGrossAmount: number;
  countyGrossAmount: number;
  cityGrossAmount: number;
  districtGrossAmount: number;
  stateTaxAmount: number;
  countyTaxAmount: number;
  cityTaxAmount: number;
  districtTaxAmount: number;
  totalTaxAmount: number;
  administeredBy: string;
  filingPeriodDisplay: string;
}